import Moment from 'moment'

export default {
  file: {
    formatBytes (bytes, decimals) {
      if (bytes === 0) return '0 Bytes'
      const dm = decimals || 2
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const index = Math.floor(Math.log(bytes) / Math.log(1024))
      const size = parseFloat((bytes / Math.pow(1024, index)).toFixed(dm))
      return `${size} ${sizes[index]}`
    }
  },
  datepicker: {
    dateFormatter: (date) => {
      return date.toLocaleDateString('pt-BR')
    },
    dateParser: (date) => {
      return Date(date.parse(date))
    },
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    dayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dateMomentFormatter: (date) => {
      return Moment(date).format('DD/MM/YYYY')
    }
  },
  money: {
    unformat (input, precision) {
      const negative = input.indexOf('-') >= 0 ? -1 : 1
      const numbers = this.onlyNumbers(input)
      const currency = this.numbersToCurrency(numbers, precision)
      return parseFloat(currency) * negative
    },
    onlyNumbers (input) {
      return this.toStr(input).replace(/\D+/g, '') || '0'
    },
    fixed (precision) {
      return this.between(0, precision, 20)
    },
    between (min, n, max) {
      return Math.max(min, Math.min(n, max))
    },
    numbersToCurrency (numbers, precision) {
      const exp = Math.pow(10, precision)
      const float = parseFloat(numbers) / exp
      return float.toFixed(this.fixed(precision))
    },
    toStr (value) {
      return value ? value.toString() : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/util.js